export default __webpack_public_path__ + "static/media/tarra-logotype-l.b0031f27.svg";